import { HistoryOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';

import FileHistoryEvent from './fileHistoryEvent';
import Loader from 'components/v2/common/loader';
import Result from 'components/v2/common/Result';

import useTranslate from 'hooks/useTranslate';
import type { HistoryTimelineEvent } from 'types';

interface FileHistoryListProps {
    events: HistoryTimelineEvent[];
    loading?: boolean;
    emptyTitle?: string;
    emptyDescription?: string;
    clientId?: number | null;
}

const FileHistoryList = ({
    events,
    loading,
    emptyTitle = 'noFileHistory',
    emptyDescription = 'noFileHistoryDescription',
    clientId,
}: FileHistoryListProps) => {
    const { translate } = useTranslate();

    if (loading) {
        return <Loader message={translate('loading')} isCircular rootSx={{ py: 4 }} />;
    }

    if (!events.length) {
        return (
            <Result
                icon={<HistoryOutlined sx={{ fontSize: 32 }} />}
                title={translate(emptyTitle)}
                description={translate(emptyDescription)}
            />
        );
    }

    return (
        <Box
            component="ul"
            sx={{
                listStyle: 'none',
                m: 0,
                p: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
            }}
        >
            {events.map((event) => (
                <FileHistoryEvent key={event.id} event={event} clientId={clientId} />
            ))}
        </Box>
    );
};

export default FileHistoryList;
